// Geração de slug a partir do nome da entidade. Usada no front (para preencher o
// campo enquanto o usuário digita o nome) e no back (para preencher quando o
// cliente não mandar nada). O campo continua editável — ver docs/validacao-prototipo.md.
/** "Minha Entidade" -> "minha-entidade". Remove acentos, pontuação e espaços repetidos. */
export function slugify(input) {
    return input
        .normalize('NFD')
        .replace(/[̀-ͯ]/g, '')
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '')
        .slice(0, 80);
}
